import { isEmpty } from "lodash";
import { View } from "react-native";
import { IconButton, TouchableRipple, useTheme } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import ConsumerContactInfo from "./ConsumerContactInfo";
import { ConsumerContactInfoError } from "./ConsumerContactInfoError";
import ConsumerFulfillmentInfo from "./ConsumerFulfillmentInfo";
import useSnackbar from "../../../../../contexts/SnackbarContext";
import useTransactionDetailsAPI from "../../../contexts/TransactionDetailsAPIContext";
import { TransactionDetails } from "../../../types";
import ActionButton from "../../ActionButton";
import CardText from "../../CardText";
import StatusLabel from "../../StatusLabel";
import TransactionCard from "../../TransactionCard";
import TransactionQRModal from "../TransactionQRModal";

type Props = {
  consumer: TransactionDetails["consumer"];
};

export default function ConsumerCard({ consumer }: Props) {
  const { name, fulfillment, contact, availableActions } = consumer;

  const tailwind = useTailwind();

  return (
    <TransactionCard>
      <View style={tailwind("gap-4")}>
        <View style={tailwind("flex-row justify-between")}>
          <CardText.Title text="Cliente" />
          {fulfillment?.status && <StatusLabel {...fulfillment.status} />}
        </View>
        <ConsumerName name={name} />
        <ActionButton action={availableActions.markAsReadyForPickup} />
        {consumer.fulfillment?.tracking_instructions && (
          <CardText.Label
            text={consumer.fulfillment.tracking_instructions}
            style={tailwind("mt-2 mb-3")}
          />
        )}
        <ActionButton action={availableActions.markAsDelivered} />
        <ConsumerFulfillmentInfo fulfillment={fulfillment} />
        {isEmpty(contact) && <ConsumerContactInfoError />}
        <View style={tailwind("flex-row items-center self-end")}>
          <ActionButton
            action={availableActions.resendPaymentRequestUrl}
            style={tailwind("flex-1")}
          />
          {availableActions.resendPaymentRequestUrl.enabled && (
            <TransactionQRModal
              url={availableActions.resendPaymentRequestUrl.params.url}
            />
          )}
        </View>
        <ConsumerContactInfo contact={contact} />
        <ActionButton action={availableActions.copyFulfillmentDetails} />
        <ActionButton action={availableActions.trackOrder} />
      </View>
    </TransactionCard>
  );
}

function ConsumerName({ name }: { name: string }) {
  const tailwind = useTailwind();
  const { colors } = useTheme();

  const { copyToClipboard } = useTransactionDetailsAPI();
  const { showMessage } = useSnackbar();

  function copy() {
    copyToClipboard(name);
    showMessage("Nombre de cliente copiado");
  }

  return (
    <TouchableRipple onPress={copy} style={tailwind("-mx-4 px-4")}>
      <View style={tailwind("flex-row justify-between items-center")}>
        <CardText.Body text={name} />
        <IconButton
          icon="content-copy"
          iconColor={colors.onSecondaryContainer}
          onPress={copy}
          style={tailwind("m-1")}
        />
      </View>
    </TouchableRipple>
  );
}
